// extracted by mini-css-extract-plugin
module.exports = {"container":"payoutsrow_container__Kuoyd","plan_purchase":"payoutsrow_plan_purchase__3Wq8a","no_purchase":"payoutsrow_no_purchase__2quGe"};